import styled from 'styled-components'
import { StyledButton } from './Button.styles'

export const StyledIconButton = styled(StyledButton)`
  justify-content: center;
  padding: 1em;

  > svg {
    margin: 0;
    width: 1.2em !important;
    height: 1.2em !important;
  }
`
